(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('RegionalFranchiserListController', RegionalFranchiserListController)

    /** @ngInject */
    function RegionalFranchiserListController($httpParamSerializer, RegionalService, ROUTES, LoadingHelper, sweetAlert, UtilHelper, MeService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedSearchField && vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getRegionals(start, number, tableState);
        }

        vm.configureReportDownload = () => {
            LoadingHelper.startLoading('.btn-download', true);
            vm.isLoadingDownloadData = true;

            const parameters = prepareParameters(0, 0, null);

            MeService
                .getDownloadToken()
                .then(success => {
                    vm.isLoadingDownloadData = false;
                    LoadingHelper.stopLoading('.btn-download', true);

                    window.open(`${ROUTES.API}/regional-report?Token=${success}&${$httpParamSerializer(parameters)}`, '_blank');
                }, error => {
                    vm.isLoadingDownloadData = false;
                    LoadingHelper.stopLoading('.btn-download', true);
                    UtilHelper.errorCallback(error);
                })
        }

        vm.openMigrationModal = () => {
            vm.regionalOrigin = null;
            vm.regionalDestination = null;

            $('#regional-migration').appendTo('body').modal('show');

            LoadingHelper.startLoading('.modal-loader');

            RegionalService
                .getAll()
                .then(success => {
                    vm.migrationRegionals = success.Registers;
                    LoadingHelper.stopLoading('.modal-loader');
                }, error => {
                    vm.migrationRegionals = null;

                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.modal-loader');
                })
        }

        vm.closeMigrationModal = () => {
            $('#regional-migration').modal('hide');
        }

        vm.migrateRegisters = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Todas as empresas serão migradas para a nova regional. Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.modal-loader');

                    RegionalService
                        .migrateData(vm.regionalOrigin.Id, vm.regionalDestination.Id)
                        .then(() => {
                            vm.closeMigrationModal();

                            UtilHelper.successCallback('migrate');
                            LoadingHelper.stopLoading('.modal-loader');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.modal-loader');
                        })
                }
            })
        }

        init();

        function getRegionals(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            RegionalService
                .getByParameters(parameters)
                .then(success => {
                    vm.regionals = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.regionals = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'RegistrationDate',
                OrderDescending: false
            }

            if (vm.selectedSearchField && vm.searchText)
                isTableSearch = true;

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'ExternalCode',
                Description: 'Código Externo'
            }, {
                Value: 'Name',
                Description: 'Descrição'
            }];
        }
    }
}());